/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is 15%, 18%, or 20% the standard tip now?`)
};

const es_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es ahora el 15%, el 18% o el 20% la propina estándar?`)
};

const de_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind 15%, 18% oder 20% heute das übliche Trinkgeld?`)
};

const nl_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is 15%, 18% of 20% tegenwoordig de standaardfooi?`)
};

const fr_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-ce que 15 %, 18 % ou 20 % est désormais le pourboire standard ?`)
};

const it_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15%, 18% o 20% è ormai la mancia standard?`)
};

const pt_br2_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15%, 18% ou 20% é a gorjeta padrão hoje em dia?`)
};

const pt_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É 15%, 18% ou 20% a gorjeta padrão atualmente?`)
};

const ja_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今の標準的なチップは15%、18%、20%のどれですか？`)
};

const zh_pct_tip_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`现在的标准小费是 15%、18% 还是 20%？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_faq4_q", locale)
	if (locale === "en") return en_pct_tip_faq4_q(inputs)
	if (locale === "es") return es_pct_tip_faq4_q(inputs)
	if (locale === "de") return de_pct_tip_faq4_q(inputs)
	if (locale === "nl") return nl_pct_tip_faq4_q(inputs)
	if (locale === "fr") return fr_pct_tip_faq4_q(inputs)
	if (locale === "it") return it_pct_tip_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_faq4_q(inputs)
	if (locale === "pt") return pt_pct_tip_faq4_q(inputs)
	if (locale === "ja") return ja_pct_tip_faq4_q(inputs)
	return zh_pct_tip_faq4_q(inputs)
};